import React from 'react';

const isSubmitting = (e: React.KeyboardEvent) => {
  const { shiftKey, key } = e;
  return !shiftKey && key === 'Enter';
};

export default isSubmitting;
